import type { SpcQuery } from '@liveline/ll_node_common/lib/models/api/spc';

/**
 * Query params for `GET .../equipment_data_tag/{id}/data/spc` (LT-3517), as sent to console_server.
 * Only the params the caller set are sent, so db_api's defaults (origin = startDate, spaced / 5 /
 * first25) apply, and a numeric 0 survives — never a truthiness test (the LT-3211 lesson).
 */
export function spcQueryParams(query: SpcQuery): Record<string, string | number> {
    const params: Record<string, string | number> = {
        startDate: query.startDate,
        endDate: query.endDate,
        bucketSeconds: query.bucketSeconds,
    };
    if (query.origin !== undefined) params.origin = query.origin;
    if (query.sampling !== undefined) params.sampling = query.sampling;
    if (query.samplesPer !== undefined) params.samplesPer = query.samplesPer;
    if (query.limitSet !== undefined) params.limitSet = query.limitSet;
    // LT-3523: the run whose annotations may exclude baseline subgroups, and the page's Apply switch.
    if (query.runId !== undefined) params.runId = query.runId;
    if (query.applyExclusions !== undefined) params.applyExclusions = query.applyExclusions ? 'true' : 'false';
    return params;
}
